export default "<svg--overlay>@{}</svg--overlay>";